import Alert from "@mui/material/Alert";

export function SnackbarSuccess(props) {
    return (
        <Alert elevation={3} variant="filled" severity="success" {...props.alertProps}>
            {props.message}
        </Alert>
    );
}
